import Seo from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { EnquiryForm } from "@/components/EnquiryForm";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/data/content";

export default function Faqs() {
  return (
    <>
      <Seo
        title="FAQs — Brightside Befriending Services, Glasgow"
        siteName="Brightside Befriending Services"
        description="Answers about PVG checks, pricing, payment, matching, visit lengths and the Glasgow areas Brightside covers."
      />
      <PageHero
        eyebrow="Questions, answered"
        lines={["Everything families", "usually ask us."]}
        text="Straight answers about safety, pricing and how visits work. Anything else — the form at the bottom lands straight in our inbox."
      />

      <section className="px-4 pb-24 sm:px-6 lg:px-8" data-testid="faq-section">
        <div className="mx-auto max-w-4xl space-y-14">
          {FAQS.map((group, gi) => (
            <div key={group.category}>
              <Reveal>
                <h2 className="font-serif text-xl text-forest sm:text-2xl" data-testid={`faq-category-${group.category.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                  {group.category}
                </h2>
              </Reveal>
              <Reveal delay={0.1}>
                <Accordion type="single" collapsible className="mt-6 space-y-3">
                  {group.items.map((item, i) => (
                    <AccordionItem
                      key={i}
                      value={`${gi}-${i}`}
                      className="rounded-2xl border border-sand bg-white px-6 transition-shadow data-[state=open]:shadow-[0_16px_36px_rgba(28,56,41,0.08)]"
                    >
                      <AccordionTrigger data-testid={`faq-trigger-${gi}-${i}`} className="py-5 text-left font-semibold text-forest hover:text-terracotta hover:no-underline">
                        {item.q}
                      </AccordionTrigger>
                      <AccordionContent className="pb-6 text-sm leading-relaxed text-pebble sm:text-base">
                        {item.a}
                      </AccordionContent>
                    </AccordionItem>
                  ))}
                </Accordion>
              </Reveal>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-white/50 px-4 py-24 sm:px-6 lg:px-8" data-testid="ask-question-section">
        <div className="mx-auto grid max-w-7xl gap-12 lg:grid-cols-2">
          <SectionHeading
            eyebrow="Still wondering?"
            title="Ask us anything — a real person replies"
            text="No chatbots, no call centres. Your question goes straight to the Brightside team and we reply within one working day."
          />
          <Reveal delay={0.15}>
            <div className="rounded-3xl border border-sand bg-white p-8 shadow-[0_16px_40px_rgba(28,56,41,0.06)] sm:p-10">
              <EnquiryForm kind="question" showService={false} buttonLabel="Ask your question" testIdPrefix="faq-question" />
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
